// API error body and codes (architecture §5.2). Used by the server (thrown) and the web client (parsed).
export type ErrorCode =
  | 'ungueltig' | 'nicht_angemeldet' | 'origin' | 'stepup_noetig' | 'falscher_code' | 'nicht_gefunden' | 'konflikt'
  | 'nicht_moeglich' | 'budget' | 'zu_viele' | 'nicht_verbunden' | 'origin_missing' | 'runtime_fehlt' | 'intern';

/** Default HTTP status per code. `falscher_code` (wrong setup code) and `intern` are WP0 additions to the §5.2 table. */
export const ERROR_STATUS: Record<ErrorCode, number> = {
  ungueltig: 400, nicht_angemeldet: 401, origin: 403, stepup_noetig: 403, falscher_code: 403, nicht_gefunden: 404,
  konflikt: 409, nicht_moeglich: 422, budget: 423, zu_viele: 429, nicht_verbunden: 503, origin_missing: 503,
  runtime_fehlt: 503, intern: 500,
};

export interface ApiErrorBody { error: { code: ErrorCode | (string & {}); message: string; details?: unknown } }

export interface BudgetErrorDetails { capEur: number; spentEur: number; scope: 'monat' | 'agent' }

/** Thrown by server handlers and by the web `api()` client. `message` is German and may be shown to Chris. */
export class ApiError extends Error {
  readonly status: number;
  readonly code: ErrorCode | (string & {});
  readonly details: unknown;
  constructor(status: number, code: ErrorCode | (string & {}), message: string, details?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }
  static of(code: ErrorCode, message: string, details?: unknown): ApiError {
    return new ApiError(ERROR_STATUS[code], code, message, details);
  }
  toBody(): ApiErrorBody {
    return { error: { code: this.code, message: this.message, ...(this.details === undefined ? {} : { details: this.details }) } };
  }
}

export function isApiErrorBody(v: unknown): v is ApiErrorBody {
  if (typeof v !== 'object' || v === null || !('error' in v)) return false;
  const e = (v as { error: unknown }).error;
  return typeof e === 'object' && e !== null && typeof (e as { code?: unknown }).code === 'string' && typeof (e as { message?: unknown }).message === 'string';
}
